import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
} from '@mui/material';

interface SupplierFormData {
  basicDetails: any;
  thirdPartyRisk: any;
  approvalDueDiligence: any;
  commercialDueDiligence: any;
  bids: any;
}

interface SupplierReviewFormProps {
  formData: SupplierFormData;
}

const SupplierReviewForm: React.FC<SupplierReviewFormProps> = ({ formData }) => {
  const renderSection = (title: string, data: any) => {
    return (
      <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
          {title}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {Object.entries(data).map(([key, value]) => (
            <Box key={key}>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
              </Typography>
              <Typography variant="body1">
                {(value as string) || 'Not provided'}
              </Typography>
            </Box>
          ))}
        </Box>
      </Paper>
    );
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom align="center" sx={{ mb: 4 }}>
        Review Supplier Due Diligence Information
      </Typography>

      {renderSection('A. Basic Details', formData.basicDetails)}
      {renderSection('B. Third Party Risk Profile', formData.thirdPartyRisk)}
      {renderSection('C. Commercial Due Diligence', formData.commercialDueDiligence)}
      {renderSection('D. Bids', formData.bids)}

      <Paper elevation={2} sx={{ p: 3, mt: 4, backgroundColor: 'success.light' }}>
        <Typography variant="body1" align="center">
          Please review all information carefully before submitting.
        </Typography>
      </Paper>
    </Box>
  );
};

export default SupplierReviewForm;
